import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useCredits } from "../context/CreditsContext";

export const CreditsBadge = () => {
  const { credits } = useCredits();
  if (!credits) return null;
  return (
    <Link
      to="/billing"
      data-testid="user-credits-badge"
      className="credits-glow flex items-center gap-2 h-9 pl-1.5 pr-3.5 rounded-full bg-gradient-to-r from-yellow-200 via-yellow-300 to-amber-300 border border-amber-300/80 text-amber-950 text-sm font-semibold hover:brightness-105 transition-[filter]"
      title={credits.free ? `${credits.free} free + ${credits.paid} paid credits` : `${credits.total} credits`}
    >
      <span className="w-6 h-6 rounded-full bg-slate-900 text-yellow-300 flex items-center justify-center"><Sparkles size={12} fill="currentColor" /></span>
      <span className="hidden sm:inline">Credits</span>
      <span data-testid="user-credits-total" className="font-mono text-xs bg-white/50 rounded-full px-1.5 py-0.5">{credits.total}</span>
    </Link>
  );
};

export default CreditsBadge;
